/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-console */
import { HubConnectionBuilder, HubConnectionState } from '@aspnet/signalr';
import baseUrl from 'config/baseUrl';
import { transformAzDomainsToArray, transformAzDomainsToString } from 'utils/transformAzDomains.ts';
import { addProfile, updateProfile, removeProfile } from '../reducers/profiles';
import { addProfileType, removeProfileType, updateProfileType } from '../reducers/profileTypes';

export const signalrMiddleware = (store) => {
  const connection = new HubConnectionBuilder().withUrl(`${baseUrl}/profileHub`).build();

  connection.on('ReceiveNewProfile', (profile) => {
    const transformedProfile = {
      ...profile,
      formValues: transformAzDomainsToArray(profile.formValues),
    };
    store.dispatch(addProfile(transformedProfile));
  });
  connection.on('ReceiveUpdatedProfile', (profile) => {
    const transformedProfile = {
      ...profile,
      formValues: transformAzDomainsToArray(profile.formValues),
    };
    store.dispatch(updateProfile(transformedProfile));
  });
  connection.on('ReceiveDeletedProfileId', (id) => {
    store.dispatch(removeProfile(id));
  });
  connection.on('ReceiveNewProfileType', (profileType) => {
    store.dispatch(addProfileType(profileType));
  });
  connection.on('ReceiveUpdatedProfileType', (profileType) => {
    store.dispatch(updateProfileType(profileType));
  });
  connection.on('ReceiveDeletedProfileTypeId', (id) => {
    store.dispatch(removeProfileType(id));
  });

  connection
    .start()
    .then(() => {
      console.log('signalr is connected and ready');
    })
    .catch((err) => {
      console.error(err.toString());
    });

  return (next) => (action) => {
    if (connection.connectionState === HubConnectionState.Connected) {
      switch (action.type) {
        case 'WS_SEND_NEW_PROFILE': {
          connection.invoke('SendNewProfile', action.profile).catch((err) => {
            console.error(err.toString());
          });
          return;
        }
        case 'WS_SEND_UPDATED_PROFILE': {
          connection.invoke('SendUpdatedProfile', action.profile).catch((err) => {
            console.error(err.toString());
          });
          return;
        }
        case 'WS_SEND_DELETED_PROFILE_ID': {
          connection.invoke('SendDeletedProfileId', action.id).catch((err) => {
            console.error(err.toString());
          });
          return;
        }
      }
    }

    return next(action);
  };
};

export const wsSendNewProfile = (profile) => ({
  type: 'WS_SEND_NEW_PROFILE',
  profile: {
    ...profile,
    formValues: transformAzDomainsToString(profile.formValues),
  },
});

export const wsSendUpdatedProfile = (profile) => ({
  type: 'WS_SEND_UPDATED_PROFILE',
  profile: {
    ...profile,
    formValues: transformAzDomainsToString(profile.formValues),
  },
});

export const wsSendDeletedProfileId = (id) => ({
  type: 'WS_SEND_DELETED_PROFILE_ID',
  id,
});
